document.addEventListener('DOMContentLoaded', function() {
  
  
   const carousels = document.querySelectorAll('.joe-slider-blog_container');

  // 创建视口观察器
  const carouselObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // 当轮播图进入视口时，初始化该轮播图
        initCarousel(entry.target);
        // 初始化后取消观察此轮播图
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '200px', // 提前200px开始加载
    threshold: 0.1      // 当10%的元素可见时触发
  });
  
  // 开始观察所有轮播图
  carousels.forEach(carousel => {
    carouselObserver.observe(carousel);
  });
  
  function initCarousel(carousel){
       const sectionId = carousel.getAttribute('data-section-id');
      const itemsContainer = carousel.querySelector(`.joe-slider-blog_items `); 
      const items =  carousel.querySelectorAll(`.joe-slider-blog_item`);
      const prevButton = carousel.querySelector(`.joe-slider-blog_prev`); 
      const nextButton = carousel.querySelector(`.joe-slider-blog_next`); 


      // 计算滚动距离
     const cardNumber = parseInt( itemsContainer.getAttribute("data-slider-cards")) || 1;
      const cardElem = itemsContainer.querySelector('div.joe-slider-blog_item');
      if (!cardElem) return;
      
      const cardWidth = cardElem.offsetWidth;
      const gap = parseInt(window.getComputedStyle(itemsContainer).columnGap) || 0;
      const scrollDistance = (cardWidth + gap) * cardNumber;

    
      
     // 使用当前容器的按钮绑定事件
      if (nextButton) {
        nextButton.addEventListener('click', currentNextHandler);
      }
      
      if (prevButton) {
        prevButton.addEventListener('click', currentPrevHandler);
      }
  
/*文件函数暂缓区*/

    function updatScrollListener(slider) {
          let scrollTimeout;
        const scrollListener = function() {
          // 清除之前的定时器
          clearTimeout(scrollTimeout);
          
          // 设置新的定时器
          scrollTimeout = setTimeout(() => {
            // 移除监听器
            slider.removeEventListener('scroll', scrollListener);
          }, 150);
        };

        // 添加滚动事件监听
        slider.addEventListener('scroll', scrollListener);
    }
    
      // 创建事件处理函数
      function currentNextHandler() {
        updatScrollListener(itemsContainer);
        
        itemsContainer.scrollBy({
          left: scrollDistance,
          behavior: 'smooth'
        });

        
      };
      
      function currentPrevHandler() {
        updatScrollListener(itemsContainer);
        
            itemsContainer.scrollBy({
              left: -scrollDistance,
              behavior: 'smooth'
            });

      };
      
/*文件函数暂缓区 end*/

    
    // 获取所有视频卡片
    const videoScrollContainer = carousel.querySelector('.joe-slider-blog_items');
    const videoItems = carousel.querySelectorAll('.joe-slider-blog_item');
    const navBarContainer = carousel.querySelector('.joe-slider-blog_nav');
    const navBar = navBarContainer.querySelector('.joe-slider-blog_nav-bar');
     
    const totalvideoItems = videoItems.length;
    const navWidth = navBarContainer.scrollWidth;
    const navBarWidth = `${navWidth / totalvideoItems}`;
     let isVideoScrolling;
    let currentVideoIndex = 0;
     let prevVideoIndex = 0;

     navBar.style.width = `${navBarWidth}px`;
     // 初始检测
    setTimeout(() => {
      currentVideoIndex = getcurrentVideoIndex();
      handleNavChange(currentVideoIndex);
    }, 100);
     
    // 获取当前可见卡片索引的函数
    function getcurrentVideoIndex() {
      const containerRect = videoScrollContainer.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;
      
      let closestCard = null;
      let minDistance = Infinity;
      let closestIndex = 0;
      
      videoItems.forEach((card, index) => {
        const cardRect = card.getBoundingClientRect();
        const cardCenter = cardRect.left + cardRect.width / 2;
        const distance = Math.abs(containerCenter - cardCenter);
        
        if (distance < minDistance) {
          minDistance = distance;
          closestCard = card;
          closestIndex = index;
        }
      });
      
      return closestIndex;
    }

     // 滚动事件监听
    videoScrollContainer.addEventListener('scroll', function() {
      // 清除之前的定时器
      window.clearTimeout(isVideoScrolling);
      
      // 设置新的定时器 - 在滚动停止200ms后触发
      isVideoScrolling = setTimeout(function() {
        // 滚动停止后的处理
        const newIndex = getcurrentVideoIndex();
        
        // 仅当索引改变时执行
        if (newIndex !== currentVideoIndex) {
          currentVideoIndex = newIndex;
          
          // 在这里执行你需要的操作，例如播放视频
          handleNavChange(currentVideoIndex);
        }
      }, 200);
    }, { passive: true });
    


     //处理底下同步nav的滚动变化
     function handleNavChange(index) {
       navBar.style.left = `${navBarWidth * index}px`;
     }
     

   

  
};
  })